import { render, staticRenderFns } from "./InsiderTipElementPageLink.vue?vue&type=template&id=317d5900&"
import script from "./InsiderTipElementPageLink.vue?vue&type=script&lang=js&"
export * from "./InsiderTipElementPageLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports